<template>
    <b-icon icon="circle-fill" class="dumpling" font-scale="0.8"
        :class="'color_risk_' + level"
        v-b-tooltip.hover
        :title="title"
    >
    </b-icon>
</template>

<script>
import formattersMixin from "@/plugins/formattersMixin.js"

export default {
    name: "risk-level-dumpling",
    mixins: [formattersMixin],
    props: {
        value: {type: [String, Number], default: null},
        level: {type: String}
    },
    computed: {
        title: function() {
            if (this.value === null) {
                return ""
            }

            return this.$t(`risk.levelFull.${this.level}`) + (this.level != 'no' ? ` ${this.formatPercentage(this.value, 2)}` : '')
        }
    }
}
</script>

<style scoped lang="scss">
.dumpling {
    position: relative;
    top: -1px;
}
</style>